import {NgModule} from '@angular/core';
import {CustomerOrdersComponent} from "@iw-shop/customer/components/orders/customer-orders.component";
import {CustomerDocumentsComponent} from "@iw-shop/customer/components/documents/customer-documents.component";
import {CustomerFavoritesComponent} from "@iw-shop/customer/components/favorites/customer-favorites.component";
import {CustomerDataComponent} from "@iw-shop/customer/components/data/customer-data.component";
import {CustomerAddressesComponent} from "@iw-shop/customer/components/addresses/customer-addresses.component";
import {
    CustomerAddressesOverviewComponent
} from "@iw-shop/customer/components/addresses-overview/customer-addresses-overview.component";
import {CustomerRegisterComponent} from "@iw-shop/customer/components/register/customer-register.component";
import {CommonModule, NgClass, NgIf} from "@angular/common";
import {ReactiveFormsModule} from "@angular/forms";
import {MyFormsModule} from "@iw-shop/forms/my-forms.module";
import {ArticleModule} from "@iw-shop/article/article.module";
import {CoreModule} from "@iw-shop/core/core.module";
import {CaptchaModule} from "@iw-shop/captcha/captcha.module";
import {RouterLink} from "@angular/router";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {DynamicArticleModule} from "@iw-shop/dynamic-article/dynamic-article.module";
import {
    CustomerDynamicArticlesComponent
} from "@iw-shop/customer/components/dynamic-articles/customer-dynamic-articles.component";
import {PasswordModule} from "primeng/password";
import {SelectButtonModule} from "primeng/selectbutton";
import {CdkDrag, CdkDragHandle, CdkDropList} from "@angular/cdk/drag-drop";
import {CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {DatePicker} from "primeng/datepicker";
import {FormErrorComponent} from "@iw-shop/forms/components/error/form-error.component";

@NgModule({
    declarations: [
        CustomerRegisterComponent,
        CustomerAddressesOverviewComponent,
        CustomerAddressesComponent,
        CustomerDataComponent,
        CustomerDynamicArticlesComponent,
        CustomerFavoritesComponent,
        CustomerDocumentsComponent,
        CustomerOrdersComponent,
    ],
    imports: [
        NgClass,
        NgIf,
        CommonModule,
        ReactiveFormsModule,
        MyFormsModule,
        ArticleModule,
        CoreModule,
        CaptchaModule,
        RouterLink,
        FontAwesomeModule,
        DynamicArticleModule,
        PasswordModule,
        SelectButtonModule,
        CdkDropList,
        CdkDrag,
        CdkDragHandle,
        CdkVirtualScrollViewport,
        CdkFixedSizeVirtualScroll,
        CdkVirtualForOf,
        DatePicker,
        FormErrorComponent
    ],
    exports: [
        CustomerRegisterComponent,
        CustomerAddressesOverviewComponent,
        CustomerAddressesComponent,
        CustomerDataComponent,
        CustomerDynamicArticlesComponent,
        CustomerFavoritesComponent,
        CustomerDocumentsComponent,
        CustomerOrdersComponent
    ]
})
export class CustomerModule {
}
